const settle = {
  'settle.title': 'Расчётный документ',
  'settle.goSettle': 'Перейти к оплате',
  'settle.productInfo': 'Информация о товаре',
  'settle.table.column.index': '№',
  'settle.table.column.image': 'Изображение товара',
  'settle.table.column.detail': 'Детали комплектующих',
  'settle.table.column.replaceNumber': 'Заменяемый номер',
  'settle.table.column.price': 'Цена',
  'settle.table.column.quantity': 'Количество',
  'settle.selected': 'Выбрано товаров: {count} шт.',
  'settle.totalQuantity': 'Общее количество: {quantity} шт.',
  'settle.goToOrder': 'Оформить заказ',

  'settle.deliveryMethod': 'Требования к доставке',
  'settle.deliveryMethod.placeholder': 'Пожалуйста, выберите требования к доставке',
  'settle.deliveryMethod.normal': 'Стандартный',
  'settle.deliveryMethod.normal.desc': 'Обычный способ доставки',
  'settle.deliveryMethod.urgent': 'Срочный',
  'settle.deliveryMethod.urgent.desc':
    'Ускоренный заказ будет обработан и организован для авиаперевозки в первую очередь, с более быстрым временем доставки и более высокой стоимостью',

  // Валидация формы и сообщения операций
  'settle.form.validation.error': 'Пожалуйста, проверьте поля формы',
  'settle.address.required': 'Пожалуйста, выберите адрес доставки',
  'settle.product.required': 'Пожалуйста, выберите хотя бы один товар',
  'settle.order.submitting': 'Оформление заказа...',
  'settle.order.success': 'Заказ успешно оформлен',
  'settle.order.failed': 'Ошибка при оформлении заказа',
  'settle.order.retry': 'Ошибка при оформлении заказа, попробуйте снова',

  'settle.message.invalidSelectedProducts':
    'Некоторые количества товаров не соответствуют требованиям, пожалуйста, проверьте',

  'settle.order.failedModal.title':
    'Ошибка при оформлении заказа, количество товаров не соответствует требованиям',
  'settle.order.failedModal.content':
    'Количество товаров должно быть больше минимального количества и кратно количеству, кратному продаже. Пожалуйста, измените количество товаров и повторите попытку.',
  'settle.order.failedModal.product': 'Наименование товара',
  'settle.order.failedModal.quantity': 'Текущее количество',
  'settle.order.failedModal.min_sale_count': 'Минимальное количество',
  'settle.order.failedModal.multiple_sale_count': 'Количество, кратное продаже',
  'settle.order.failedModal.error_message': 'Сообщение об ошибке',
};

export default settle;
